// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Styles co-localises de l'onglet Notifications et signatures commande-MS (V2).

   La racine de l'onglet est \`.opms__marche\` — meme classe que la case soeur ACHETEUR
   (OperationMarche), pour heriter de sa mise en page (accordeons, recap, preview PDF, lignes
   candidats, barre d'actions). L'ancienne racine \`.tab-marche\` n'existe plus.

   Les blocs \`signature-*\` n'etaient styles nulle part en global : ils dependaient des CSS LEGACY
   (\`SuiviDeCommande.css\` / \`SuiviOperation.css\`, regles scopees \`.tab-marche .signature-pending\`).
   Dependance accidentelle et fragile : on la coupe en portant les regles ici, scopees sur la racine
   de ce fork. Le composant est desormais autonome (charte : fork autonome, zero CSS orphelin). */

.opms__marche .signature-pending {
  padding: 2rem;
  background-color: #f9fafb;
  border-radius: 0.8rem;
  margin-bottom: 2rem;
}

.opms__marche .signature-pending > h4 {
  font-size: 1.8rem;
  margin-top: 1rem;
  margin-bottom: 1rem;
  color: #2c3948;
}

.opms__marche .signature-pending p {
  margin-bottom: 1.5rem;
  color: #4b5563;
}

/* Nom du signataire designe mis en avant dans le message "non designe". */
.opms__marche span.signataire {
  font-weight: 800;
}
`, "",{"version":3,"sources":["webpack://./src/pages/SuiviDeCommandeMSV2/components/CommandeMsMarche.css"],"names":[],"mappings":"AAAA;;;;;;;;;iGASiG;;AAEjG;EACE,aAAa;EACb,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA,0EAA0E;AAC1E;EACE,gBAAgB;AAClB","sourcesContent":["/* Styles co-localises de l'onglet Notifications et signatures commande-MS (V2).\n\n   La racine de l'onglet est `.opms__marche` — meme classe que la case soeur ACHETEUR\n   (OperationMarche), pour heriter de sa mise en page (accordeons, recap, preview PDF, lignes\n   candidats, barre d'actions). L'ancienne racine `.tab-marche` n'existe plus.\n\n   Les blocs `signature-*` n'etaient styles nulle part en global : ils dependaient des CSS LEGACY\n   (`SuiviDeCommande.css` / `SuiviOperation.css`, regles scopees `.tab-marche .signature-pending`).\n   Dependance accidentelle et fragile : on la coupe en portant les regles ici, scopees sur la racine\n   de ce fork. Le composant est desormais autonome (charte : fork autonome, zero CSS orphelin). */\n\n.opms__marche .signature-pending {\n  padding: 2rem;\n  background-color: #f9fafb;\n  border-radius: 0.8rem;\n  margin-bottom: 2rem;\n}\n\n.opms__marche .signature-pending > h4 {\n  font-size: 1.8rem;\n  margin-top: 1rem;\n  margin-bottom: 1rem;\n  color: #2c3948;\n}\n\n.opms__marche .signature-pending p {\n  margin-bottom: 1.5rem;\n  color: #4b5563;\n}\n\n/* Nom du signataire designe mis en avant dans le message \"non designe\". */\n.opms__marche span.signataire {\n  font-weight: 800;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
